import React from 'react'
import './cover.css'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';



const LARGE_NAME_FONTS = [
  "Playfair Display, serif",
  "Cinzel Decorative, serif",
];


const Nophotocover = ({onScrollClick,details,showScrollIndicator,hideScrollIndicator}) => {
  const isLargeNameFont = LARGE_NAME_FONTS.includes(
  details?.nameFontStyle
);


  const groomNameBanner=()=>{
    return( <h3
      className={`t5-cover-name ${
        isLargeNameFont ? "t5-cover-name--compact" : ""
      }`}
      style={{ fontFamily: details.nameFontStyle }}
    >
      {details?.groomName}
    </h3>)
  }

  const brideNameBanner=()=>{
     return(  <h3
      className={`t5-cover-name ${
        isLargeNameFont ? "t5-cover-name--compact" : ""
      }`}
      style={{ fontFamily: details.nameFontStyle }}
    >
      {details?.brideName}
    </h3>)
  }

 
  return (
   <section className='cover no-photo-cover theme-5-cover cover-animate'>
  <picture>
  {/* Desktop */}
  <source
    media="(min-width: 768px)"
    srcSet={`
      https://res.cloudinary.com/depixc8dq/image/upload/w_1080/v1789009461/aamantran%20assets/desktop_hero_frame_1_oqbmkh.png 1080w,
      https://res.cloudinary.com/depixc8dq/image/upload/w_1920/v1789009461/aamantran%20assets/desktop_hero_frame_1_oqbmkh.png 1920w
    `}
    sizes="100vw"
  />

  {/* Mobile */}
  <img
    src="https://res.cloudinary.com/depixc8dq/image/upload/v1789009460/aamantran%20assets/phone_hero_section_1_zxjjyz.png"
    srcSet={`
      https://res.cloudinary.com/depixc8dq/image/upload/w_320/v1789009460/aamantran%20assets/phone_hero_section_1_zxjjyz.png 320w,
      https://res.cloudinary.com/depixc8dq/image/upload/w_640/v1789009460/aamantran%20assets/phone_hero_section_1_zxjjyz.png 640w,
      https://res.cloudinary.com/depixc8dq/image/upload/w_1080/v1789009460/aamantran%20assets/phone_hero_section_1_zxjjyz.png 1080w
    `}
    sizes="100vw"
    className="theme-5-cover-frame"
    alt="cover background"
  />
</picture>
   <div className="t5-cover-details">
     <span className="t5-no-photo-cover-content">
          We are honored to welcome you to the wedding ceremony of
        </span>
          <div className="t5-cover-name-wrapper">

              {details?.displayOrder==="groomFirst"?<>
               {groomNameBanner()}
            <span
  className={`t5-cover-and ${
    isLargeNameFont ? "t5-cover-and--compact" : ""
  }`}
  style={{ fontFamily: details.nameFontStyle }}
>
  &
</span>
              {brideNameBanner()}
         </>:<>
                {brideNameBanner()}
            <span
  className={`t5-cover-and ${
    isLargeNameFont ? "t5-cover-and--compact" : ""
  }`}
  style={{ fontFamily: details.nameFontStyle }}
>
  &
</span>
                 {groomNameBanner()} 
         </>}
          </div>
                       {details?.hashtag && (
    <div className="t5-cover-hashtag">#{details.hashtag}</div>
)}
</div>
      {showScrollIndicator && (<div  className={`t5-scroll-indicator ${ hideScrollIndicator ? "hide" : ""}`} onClick={onScrollClick}>
                      <ExpandMoreIcon className='t5-scroll-indication-icon' />
                    <span>SCROLL</span>
                  </div>) }
   </section>
  )
}

export default Nophotocover